<template>
  <div class="app-header">
    <div class="header-bg"></div>
    <div class="header-content">
      <!-- Logo区域 -->
      <div class="logo-section" @click="navigateTo('/kline/day')">
        <div class="logo-icon">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="8" width="40" height="32" rx="4" stroke="currentColor" stroke-width="2"/>
            <path d="M12 24L18 18L24 24L30 16L36 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 32V28M18 32V26M24 32V28M30 32V22M36 32V28" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="logo-text">
          <span class="logo-title">StockVision</span>
          <span class="logo-subtitle">智能股票分析平台</span>
        </div>
      </div>

      <!-- 导航菜单 -->
      <el-menu
        :default-active="activeMenu"
        mode="horizontal"
        class="nav-menu"
      >
        <!-- K线分析 -->
        <el-submenu index="kline">
          <template slot="title">
            <i class="el-icon-data-line"></i>
            <span>K线分析</span>
          </template>
          <el-menu-item @click="navigateTo('/kline/day')">
            <i class="el-icon-data-line"></i>
            <span>日K线</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/kline/week')">
            <i class="el-icon-data-analysis"></i>
            <span>周K线</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/kline/5min')">
            <i class="el-icon-time"></i>
            <span>5分钟</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/kline/5day')">
            <i class="el-icon-notebook-2"></i>
            <span>5日K线</span>
          </el-menu-item>
        </el-submenu>

        <!-- 技术指标 -->
        <el-submenu index="indicators">
          <template slot="title">
            <i class="el-icon-odometer"></i>
            <span>技术指标</span>
          </template>
          <el-menu-item @click="navigateTo('/macd')">
            <i class="el-icon-data-line"></i>
            <span>MACD指标</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/rsi')">
            <i class="el-icon-odometer"></i>
            <span>RSI指标</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/momentum')">
            <i class="el-icon-reading"></i>
            <span>动量指标</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/kdj')">
            <i class="el-icon-data-board"></i>
            <span>KDJ指标</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/bollinger')">
            <i class="el-icon-data-line"></i>
            <span>布林线</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/obv')">
            <i class="el-icon-data-analysis"></i>
            <span>OBV能量潮</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/vpt')">
            <i class="el-icon-data-board"></i>
            <span>VPT价量趋势</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/ad')">
            <i class="el-icon-odometer"></i>
            <span>AD累积派发</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/mfi')">
            <i class="el-icon-data-board"></i>
            <span>MFI资金流量</span>
          </el-menu-item>
        </el-submenu>

        <!-- 智能筛选 -->
        <el-submenu index="screening">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>智能筛选</span>
          </template>
          <el-menu-item @click="navigateTo('/industry')">
            <i class="el-icon-s-grid"></i>
            <span>行业筛选</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/trend')">
            <i class="el-icon-data-line"></i>
            <span>趋势查询</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/trend-list')">
            <i class="el-icon-s-data"></i>
            <span>趋势筛选</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/momentum-list')">
            <i class="el-icon-s-data"></i>
            <span>动量筛选</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/custom-query')">
            <i class="el-icon-setting"></i>
            <span>自定义查询</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/sector')">
            <i class="el-icon-menu"></i>
            <span>板块选股</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/mfi-oversold')">
            <i class="el-icon-data-board"></i>
            <span>指标筛选</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/favorite')">
            <i class="el-icon-star-on"></i>
            <span>自选股票</span>
          </el-menu-item>
        </el-submenu>

        <!-- 流向分析 -->
        <el-submenu index="flow-analysis">
          <template slot="title">
            <i class="el-icon-money"></i>
            <span>流向分析</span>
          </template>
          <el-menu-item @click="navigateTo('/bill/day')">
            <i class="el-icon-money"></i>
            <span>资金流向（日级别）</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/bill/minute')">
            <i class="el-icon-data-line"></i>
            <span>资金流向（分钟级）</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/bill/tick')">
            <i class="el-icon-s-data"></i>
            <span>分笔成交明细</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/iceberg')">
            <i class="el-icon-cold-drink"></i>
            <span>Tick冰山检测</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/iceberg-minute')">
            <i class="el-icon-data-analysis"></i>
            <span>分钟级冰山检测</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/realtime-quote')">
            <i class="el-icon-monitor"></i>
            <span>实时行情</span>
          </el-menu-item>
        </el-submenu>

        <!-- 量化交易 -->
        <el-submenu index="quant-trading">
          <template slot="title">
            <i class="el-icon-data-analysis"></i>
            <span>量化交易</span>
          </template>
          <el-menu-item @click="navigateTo('/backtest')">
            <i class="el-icon-data-analysis"></i>
            <span>布林线策略</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/optimize')">
            <i class="el-icon-setting"></i>
            <span>布林线参数</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/macd-backtest')">
            <i class="el-icon-data-line"></i>
            <span>MACD策略</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/macd-optimize')">
            <i class="el-icon-s-tools"></i>
            <span>MACD参数</span>
          </el-menu-item>
        </el-submenu>

        <!-- 系统管理 -->
        <el-menu-item @click="navigateTo('/scheduled-tasks')">
          <i class="el-icon-timer"></i>
          <span>定时任务</span>
        </el-menu-item>
      </el-menu>

      <!-- 用户信息区域 -->
      <div class="user-section">
        <el-dropdown @command="handleUserAction" trigger="click">
          <div class="user-avatar">
            <div class="avatar-content">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M12 14C8.13401 14 5 17.134 5 21V22H19V21C19 17.134 15.866 14 12 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <span class="user-name">用户</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item command="profile">
              <i class="el-icon-user"></i>
              <span>个人信息</span>
            </el-dropdown-item>
            <el-dropdown-item command="settings">
              <i class="el-icon-setting"></i>
              <span>系统设置</span>
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  computed: {
    activeMenu() {
      return this.$route.path
    },
    currentStockCode() {
      return this.$route.query.code || ''
    }
  },
  methods: {
    navigateTo(path) {
      // 检查是否已经在目标页面
      const isSamePath = this.$route.path === path

      // 如果是行业筛选、趋势查询、趋势筛选、动量筛选、自定义查询、板块选股、MFI超卖区筛选、资金流向、自选股票、实时行情或冰山检测页面，不带参数
      if (path === '/industry' || path === '/trend' || path === '/trend-list' || path === '/momentum-list' || path === '/custom-query' || path === '/sector' || path === '/mfi-oversold' || path === '/bill/day' || path === '/bill/minute' || path === '/bill/tick' || path === '/favorite' || path === '/realtime-quote' || path === '/iceberg' || path === '/iceberg-minute' || path === '/flow-analysis' || path === '/scheduled-tasks') {
        if (isSamePath) return
        this.$router.push(path).catch(() => {})
        return
      }

      // 其他页面带上当前选中的股票代码
      const query = this.currentStockCode ? { code: this.currentStockCode } : {}

      // 检查 query 是否也相同
      const isSameQuery = JSON.stringify(this.$route.query) === JSON.stringify(query)

      if (isSamePath && isSameQuery) return

      this.$router.push({ path, query }).catch(() => {})
    },

    handleUserAction(command) {
      switch (command) {
        case 'profile':
          this.$message.info('个人信息功能开发中')
          break
        case 'settings':
          this.$message.info('系统设置功能开发中')
          break
        case 'logout':
          this.$confirm('确认退出登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$message.success('已退出登录')
          }).catch(() => {})
          break
      }
    }
  }
}
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(99, 102, 241, 0.15);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 50%, rgba(99, 102, 241, 0.05) 100%);
  pointer-events: none;
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 64px;
  position: relative;
  z-index: 1;
}

/* Logo区域 */
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 40px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.logo-section:hover {
  background: rgba(99, 102, 241, 0.1);
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
}

.logo-icon svg {
  width: 24px;
  height: 24px;
}

.logo-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.logo-title {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc 0%, #c4b5fd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
}

.logo-subtitle {
  font-size: 11px;
  color: #64748b;
  letter-spacing: 0.3px;
}

/* 导航菜单 */
.nav-menu {
  flex: 1;
  border-bottom: none;
  background: transparent;
}

.nav-menu :deep(.el-menu-item) {
  color: #cbd5e1;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  height: 64px;
  line-height: 64px;
  padding: 0 20px;
}

.nav-menu :deep(.el-menu-item i) {
  margin-right: 6px;
  font-size: 16px;
}

.nav-menu :deep(.el-menu-item span) {
  font-size: 14px;
}

.nav-menu :deep(.el-menu-item:hover) {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.08);
}

.nav-menu :deep(.el-menu-item.is-active) {
  color: #a5b4fc;
  border-bottom-color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
}

/* 二级菜单样式 */
.nav-menu :deep(.el-submenu__title) {
  color: #cbd5e1;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  height: 64px;
  line-height: 64px;
  padding: 0 20px;
}

.nav-menu :deep(.el-submenu__title i) {
  margin-right: 6px;
  font-size: 16px;
}

.nav-menu :deep(.el-submenu__title span) {
  font-size: 14px;
}

.nav-menu :deep(.el-submenu__title:hover) {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.08);
}

/* 二级菜单下拉面板 */
.nav-menu :deep(.el-menu--horizontal .el-submenu .el-menu) {
  background: rgba(15, 23, 42, 0.95);
  border: 1px solid rgba(99, 102, 241, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* 二级菜单项 */
.nav-menu :deep(.el-menu--horizontal .el-submenu .el-menu-item) {
  color: #cbd5e1;
  height: 44px;
  line-height: 44px;
  padding: 0 24px;
  background: transparent;
  min-width: 160px;
}

.nav-menu :deep(.el-menu--horizontal .el-submenu .el-menu-item i) {
  margin-right: 8px;
  font-size: 14px;
}

.nav-menu :deep(.el-menu--horizontal .el-submenu .el-menu-item:hover) {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.1);
}

.nav-menu :deep(.el-menu--horizontal .el-submenu .el-menu-item.is-active) {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.15);
}

/* 二级菜单箭头 */
.nav-menu :deep(.el-submenu__icon-arrow) {
  color: #64748b;
  font-size: 12px;
  margin-left: 4px;
}

/* 用户信息区域 */
.user-section {
  margin-left: 20px;
}

.user-avatar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.user-avatar:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(99, 102, 241, 0.3);
}

.avatar-content {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.avatar-content svg {
  width: 18px;
  height: 18px;
}

.user-name {
  font-size: 14px;
  color: #cbd5e1;
  font-weight: 500;
}

.user-avatar i {
  font-size: 12px;
  color: #64748b;
  transition: transform 0.3s ease;
}

.user-avatar:hover i {
  transform: rotate(180deg);
}

/* 下拉菜单样式 */
.user-dropdown {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
  border-radius: 12px !important;
  padding: 8px !important;
  margin-top: 8px !important;
}

.user-dropdown :deep(.el-dropdown-menu__item) {
  color: #e2e8f0 !important;
  padding: 10px 16px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.user-dropdown :deep(.el-dropdown-menu__item i) {
  margin-right: 10px;
  color: #94a3b8;
  font-size: 16px;
}

.user-dropdown :deep(.el-dropdown-menu__item:hover) {
  background: rgba(99, 102, 241, 0.15) !important;
  color: #a5b4fc !important;
}

.user-dropdown :deep(.el-dropdown-menu__item:hover i) {
  color: #a5b4fc;
}

.user-dropdown :deep(.el-dropdown-menu__item--divided) {
  margin-top: 8px !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
}
</style>
